import { render, staticRenderFns } from "./endBase.vue?vue&type=template&id=514c3c7a&scoped=true&"
import script from "./endBase.vue?vue&type=script&lang=js&"
export * from "./endBase.vue?vue&type=script&lang=js&"
import style0 from "./endBase.vue?vue&type=style&index=0&id=514c3c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514c3c7a",
  null
  
)

export default component.exports